import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { listPosts } from '../utils/secureFunctions';
import TopNavigation from '../components/TopNavigation';
import LeftNavSidebar from '../components/LeftNavSidebar';
import RightWidgetsSidebar from '../components/RightWidgetsSidebar';
import ImageWithFallback from '../components/ImageWithFallback';
import MediaBox from '../components/MediaBox';
import { renderTextWithLinks } from '../utils/text';
import { getProfileUrl } from '../utils/urls';

interface Post {
  id: string;
  userId: string;
  userName: string;
  userPhoto: string;
  content: string;
  imageURL?: string;
  videoURL?: string;
  likes: string[];
  comments: number;
  createdAt: any;
}

const HashtagPage: React.FC = () => {
  const { tag } = useParams<{ tag: string }>();
  const [posts, setPosts] = useState<Post[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!tag) return;
    let mounted = true;
    const load = async () => {
      try {
        const res = await listPosts({ hashtag: tag.toLowerCase(), limit: 50 });
        if (!mounted) return;
        setPosts(res.posts as any);
      } catch (e) {
        console.error('Failed to load hashtag posts', e);
      }
    };
    load();
    const t = window.setInterval(load, 20000);
    return () => {
      mounted = false;
      window.clearInterval(t);
    };
  }, [tag]);

  return (
    <div style={{ background: '#F5EDE1', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopNavigation />
      <LeftNavSidebar />
      <RightWidgetsSidebar />
      <div className="page-with-sidebars">
      <div className="page-inner">
        <h2 style={{ marginTop: 16 }}>#{tag}</h2>
        {posts.length === 0 ? (
          <p style={{ color: '#5B6E6E' }}>No posts for this hashtag yet.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {posts.map((post) => (
              <div key={post.id} style={{ background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                  <ImageWithFallback src={post.userPhoto} alt="" style={{ width: 40, height: 40, borderRadius: '50%' }} />
                  <strong style={{ cursor: 'pointer' }} onClick={() => navigate(getProfileUrl({ id: post.userId, username: (post as any).username }))}>{post.userName}</strong>
                </div>
                <div style={{ marginBottom: 8 }}>{renderTextWithLinks(post.content)}</div>
                {post.imageURL && <MediaBox src={post.imageURL} type="image" />}
                {post.videoURL && <MediaBox src={post.videoURL} type="video" controls contain />}
              </div>
            ))}
          </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default HashtagPage;
